import { useState } from "react"
import { motion, AnimatePresence } from "framer-motion"
import { Plus, Minus } from "lucide-react"

function TimelineItem({ item, index, colorTheme }) {
  const [isExpanded, setIsExpanded] = useState(false)

  return (
    <div className="border-b border-black/10 dark:border-white/10 group">
      {/* Clickable Header Row */}
      <button 
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full text-left py-8 md:py-10 flex flex-col md:flex-row md:items-center justify-between gap-4 relative overflow-hidden transition-all duration-500 hover:bg-black/[0.02] dark:hover:bg-white/[0.02] px-4 md:px-8"
      >
        <div className="flex flex-col md:flex-row md:items-baseline gap-2 md:gap-8 w-full">
          <h3 className="text-3xl md:text-5xl font-bold heading-font tracking-tighter text-zinc-900 dark:text-white group-hover:text-cyan-600 dark:group-hover:text-cyan-400 transition-colors duration-500">
            {item.institution}
          </h3>
          <span className="text-lg text-zinc-600 dark:text-zinc-500 font-light heading-font">{item.title}</span>
        </div>
        
        <div className="flex items-center gap-6 flex-shrink-0">
          <span className="text-zinc-600 dark:text-zinc-500 heading-font hidden md:block">{item.date}</span>
          <div className="w-10 h-10 rounded-full border border-black/10 dark:border-white/10 flex items-center justify-center bg-zinc-100 dark:bg-black group-hover:border-cyan-600/50 dark:group-hover:border-cyan-400/50 transition-colors">
            {isExpanded ? <Minus className="w-4 h-4 text-black dark:text-white" /> : <Plus className="w-4 h-4 text-black dark:text-white" />}
          </div>
        </div>
      </button>

      {/* Expandable Content */}
      <AnimatePresence>
        {isExpanded && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
            className="overflow-hidden"
          >
            <div className="px-4 md:px-8 pb-10 pt-4 max-w-5xl">
              <span className="text-zinc-600 dark:text-zinc-500 heading-font md:hidden block mb-6">{item.date}</span>
              <ul className="space-y-4 text-zinc-600 dark:text-zinc-400 text-lg leading-relaxed font-light md:pl-6 border-l-2 border-black/5 dark:border-white/5 ml-2 md:ml-4">
                {item.description.map((point, i) => (
                  <li key={i} className="flex gap-4">
                    <span className="text-cyan-500 mt-2 text-xs flex-shrink-0">◆</span>
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}

export function CollapsibleTimeline({ items, colorTheme }) {
  return (
    <div className="w-full">
      <div className="border-t border-black/10 dark:border-white/10">
        {items.map((item, index) => (
          <TimelineItem key={index} item={item} index={index} colorTheme={colorTheme} />
        ))}
      </div>
    </div>
  )
}
